export enum DocumentMatchStatus {
    MATCHED = "MATCHED",
    NOT_MATCHED = "NOT_MATCHED",
}
